import { Controller } from "stimulus";

export default class extends Controller {
  copyToken(event) {
    const id = event.currentTarget.dataset.id;
    const copyText = $(`#copy-link-input-${id}`);
    const copyButton = $(`#copy-link-${id}`);
    const copiedButton = $(`#copied-link-${id}`);

    copyTextToClipboard(copyText.val());

    copyButton.addClass('d-none');
    copiedButton.removeClass('d-none');

    setTimeout(() => {
      copiedButton.addClass('d-none');
      copyButton.removeClass('d-none');
    }, 3000);
  }
}
